/**
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *           _____                    _____                    _____
 *          /\    \                  /\    \                  /\    \
 *         /::\    \                /::\    \                /::\    \
 *        /::::\    \              /::::\    \               \:::\    \
 *       /::::::\    \            /::::::\    \               \:::\    \
 *      /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *     /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *    /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *   /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *  /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 * /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 * \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *  \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *   \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *    \:::\   \::::/    /              \::::/    /      \::::/____/
 *     \:::\  /:::/    /               /:::/    /        \:::\    \
 *      \:::\/:::/    /               /:::/    /          \:::\    \
 *       \::::::/    /               /:::/    /            \:::\    \
 *        \::::/    /               /:::/    /              \:::\____\
 *         \::/____/                \::/    /                \::/    /
 *          ~~                       \/____/                  \/____/
 */

/**
 *
 * @type {string}
 */
const AUTHENTICATION_TOKEN = "LS_TOKEN";

/**
 *
 * @type {string}
 */
const AUTHENTICATION_USERNAME = "LS_USERNAME";

/**
 *
 * @type {string}
 */
const AUTHENTICATION_LANGUAGE = "LS_LANGUAGE";

/**
 *
 * @type {string}
 */
const AUTHENTICATION_PROFILE_STATUS = "LS_PROFILE_STATUS";

/**
 * To set user token
 * @param token
 */
function setToken(token) {
  localStorage.setItem(AUTHENTICATION_TOKEN, token);
}

/**
 * To remove user token
 */
function removeToken() {
  localStorage.removeItem(AUTHENTICATION_TOKEN);
}

/**
 * To get user token
 */
function retrieveToken() {
  return localStorage.getItem(AUTHENTICATION_TOKEN);
}

/**
 * To set user token
 * @param mobileNumber
 */
function setUserName(mobileNumber) {
  localStorage.setItem(AUTHENTICATION_USERNAME, mobileNumber);
}

/**
 * To remove user token
 */
function removeUserName() {
  localStorage.removeItem(AUTHENTICATION_USERNAME);
}

/**
 * To get user token
 */
function retrieveUserName() {
  return localStorage.getItem(AUTHENTICATION_USERNAME);
}

/**
 * To set user language
 * @param language
 */
function setUserLanguage(language) {
  localStorage.setItem(AUTHENTICATION_LANGUAGE, language);
}

/**
 * To remove user language
 */
function removeUserLanguage() {
  localStorage.removeItem(AUTHENTICATION_LANGUAGE);
}

/**
 * To get user language
 */
function retrieveUserLanguage() {
  return localStorage.getItem(AUTHENTICATION_LANGUAGE);
}

/**
 * To set profile status
 */
function setProfileStatus() {
  return localStorage.setItem(AUTHENTICATION_PROFILE_STATUS, "true");
}

/**
 * To get profile status
 */
function retrieveProfileStatus() {
  return localStorage.getItem(AUTHENTICATION_PROFILE_STATUS);
}

/**
 * To remove profile status
 */
function removeProfileStatus() {
  return localStorage.removeItem(AUTHENTICATION_PROFILE_STATUS);
}

/**
 * To remove profile status
 */
function updateProfileStatus() {
  return localStorage.setItem(AUTHENTICATION_PROFILE_STATUS, "false");
}

export default {
  setToken,
  retrieveToken,
  removeToken,
  setUserName,
  removeUserName,
  retrieveUserName,
  setUserLanguage,
  removeUserLanguage,
  retrieveUserLanguage,
  retrieveProfileStatus,
  setProfileStatus,
  removeProfileStatus,
  updateProfileStatus
};



// WEBPACK FOOTER //
// ./src/utils/AuthManager.js